import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { ApiHook } from "../../hooks/apiHook";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { formatDateWithoutTime } from "../../utils/formateDate";

const NewMbersBookings = ({
  members,
  orders,
  hotels,
  currency,
  conversionFactor,
  userProductId,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("new-member");
  const [recruitersCheck, setRecruitersCheck] = useState(false);
  const [packageCheck, setPackageCheck] = useState(false);
  const moduleStatus = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus
  );
 console.log("currencycurrencycurrencycurrencycurrency",currency)
  //-------------------------------- API ----------------------------------------

  const handleTabChange = (tab) => {
    console.log(tab);
    setActiveTab(tab);
  };
  return (
    <div className={moduleStatus?.rank_status ? "col-md-5" : "col-md-7"}>
      <div className="joinings_viewBox ">
        <div className="joinings_viewBox_head">
          <h5>{t("yourbuness")}</h5>
        </div>
        {members && (
          <ul
            className="teamPerfomance_tab nav nav-tabs mb-3"
            id="ex1"
            role="tablist"
          >
            {members && (
              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "new-member" ? "active" : ""
                  }`}
                  id={`ex1-tab-${"new-member"}`}
                  data-bs-toggle="tab"
                  role="tab"
                  aria-controls={"new-member"}
                  aria-selected={activeTab === "new-member" ? "true" : "false"}
                  onClick={() => handleTabChange("new-member")}
                >
                  {t("members")}
                </Link>
              </li>
            )}
            {orders && (
              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "new-bookings" ? "active" : ""
                  }`}
                  id={`ex1-tab-${"new-bookings"}`}
                  data-bs-toggle="tab"
                  role="tab"
                  aria-controls={"new-bookings"}
                  aria-selected={
                    activeTab === "new-bookings" ? "true" : "false"
                  }
                  onClick={() => handleTabChange("new-bookings")}
                >
                  {t("newOrders")}
                </Link>
              </li>
            )}
            {/* {orders && (
              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "new-hotels" ? "active" : ""
                  }`}
                  id={`ex1-tab-${"new-hotels"}`}
                  data-bs-toggle="tab"
                  role="tab"
                  aria-controls={"new-hotels"}
                  aria-selected={
                    activeTab === "new-hotels" ? "true" : "false"
                  }
                  onClick={() => handleTabChange("new-hotels")}
                >
                  {t("newOrders")}
                </Link>
              </li>
            )} */}
          </ul>
        )}
        <div className="tab-content" id="ex1-content">
          {activeTab === "new-member" && (
            <div
              className={`tab-pane fade  ${
                activeTab === "new-member" ? "show active" : ""
              }`}
              id={"new-member"}
              role="tabpanel"
              aria-labelledby={"new-member"}
            >
              <div className="top_earners_Section">
                <div className="teammbrs_cnt">
                  {!members ? (
                    <div className="teammbrs_cnt_row">
                      <div className="teammbrs_cnt_img">
                        <Skeleton
                          width="45px"
                          height="45px"
                          circle
                          containerClassName="avatar-skeleton"
                          count={3}
                        />
                      </div>
                      <div className="teammbrs_cnt_name_dtl">
                        <div className="teammbrs_cnt_name">
                          <Skeleton count={6} />
                        </div>
                      </div>
                    </div>
                  ) : members?.length === 0 ? (
                    <div className="no-data-div">
                      <div className="no-data-div-image">
                        <img src="/images/nodata-image.png" alt="" />
                      </div>
                      <p>{t("noDataFound")}</p>
                    </div>
                  ) : (
                    members.map((member, index) => (
                      <div className="teammbrs_cnt_row" key={index}>
                        <div className="teammbrs_cnt_img">
                          <img
                            src={
                              member?.image
                                ? member?.image
                                : member?.gender === "F"
                                ? "/images/team1.png"
                                : member?.gender === "M"
                                ? "/images/user-profile.png"
                                : "/images/team3.png"
                            }
                            alt={member?.name}
                          />
                        </div>
                        <div className="teammbrs_cnt_name_dtl">
                          <div className="teammbrs_cnt_name">
                            {member?.name} {member?.secondName}
                          </div>
                          <div className="teammbrs_cnt_date_id">
                            <span>{member?.username}</span>
                            <span>
                              {formatDateWithoutTime(member?.dateOfJoining)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === "new-bookings" && (
            <div
              className={`tab-pane fade  teamperfomance ${
                activeTab === "new-bookings" ? "show active" : ""
              }`}
              id={"new-bookings"}
              role="tabpanel"
              aria-labelledby={"new-bookings"}
            >
              <div className="top_earners_Section">
                {!orders ? (
                  <div className="teammbrs_cnt_row">
                    <div className="teammbrs_cnt_img">
                      <Skeleton
                        circle
                        width="45px"
                        height="45px"
                        containerClassName="avatar-skeleton"
                        count={4}
                      />
                    </div>
                    <div className="teammbrs_cnt_name_dtl">
                      <div className="teammbrs_cnt_name">
                        <Skeleton count={9} />
                      </div>
                    </div>
                  </div>
                ) : orders.length === 0 ? (
                  <div className="no-data-div">
                    <div className="no-data-div-image">
                      <img src="/images/nodata-image.png" alt="" />
                    </div>
                    <p>{t("noDataFound")}</p>
                  </div>
                ) : (
                  <table style={{ width: "100%" }} className="newOrders">
                    <thead>
                      <tr>
                        <th scope="col">OrderDate</th>
                        <th scope="col">OrderNo</th>
                        <th scope="col">TotalAmount</th>
                        {/* <th scope="col">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map((item, index) => (
                        <tr>
                          <td>{formatDateWithoutTime(item.orderDate)}</td>
                          <td>{item.orderNo}</td>
                          <td>
                            <strong style={{ color: "#03AD47" }}>{`
                            ${
                              currency?.symbolLeft
                            }
                             ${CurrencyConverter(
                              item.totalAmount,
                              conversionFactor
                            )}`}</strong>
                          </td>

                          {/* <td><a href={`/repurchase-invoice/${item.orderId}`}>View</a></td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
          {activeTab === "new-hotels" && (
            <div
              className={`tab-pane fade  teamperfomance ${
                activeTab === "new-hotels" ? "show active" : ""
              }`}
              id={"new-hotels"}
              role="tabpanel"
              aria-labelledby={"new-hotels"}
            >
              <div className="top_earners_Section">
                {!hotels ? (
                  <div className="teammbrs_cnt_row">
                    <div className="teammbrs_cnt_img">
                      <Skeleton
                        circle
                        width="45px"
                        height="45px"
                        containerClassName="avatar-skeleton"
                        count={4}
                      />
                    </div>
                    <div className="teammbrs_cnt_name_dtl">
                      <div className="teammbrs_cnt_name">
                        <Skeleton count={9} />
                      </div>
                    </div>
                  </div>
                ) : hotels.length === 0 ? (
                  <div className="no-data-div">
                    <div className="no-data-div-image">
                      <img src="/images/nodata-image.png" alt="" />
                    </div>
                    <p>{t("noDataFound")}</p>
                  </div>
                ) : (
                  hotels.map((item, index) => (
                    <div key={index}>
                      <div className="teammbrs_cnt_row">
                        <div className="teammbrs_cnt_img">
                          <img
                            src={
                              item.image
                                ? item.image
                                : "/images/user-profile.png"
                            }
                            alt=""
                          />
                        </div>
                        <div className="teammbrs_cnt_name_dtl">
                          <div
                            className="teammbrs_cnt_name"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "125px",
                            }}
                          >
                            {item.name}
                            <span style={{ fontSize: "10px" }}>
                              {" "}
                              {`someone registerd  ${item.username} on ${item?.dateOfJoining}`}
                            </span>
                          </div>
                        </div>
                        {/* <div className="teamperfoamance_amount">
                          <strong style={{ color: "#03AD47" }}>{`${
                            currency?.symbolLeft
                          } ${CurrencyConverter(
                            item.balanceAmount,
                            conversionFactor
                          )}`}</strong>
                        </div> */}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewMbersBookings;
